import React from 'react';

function PageHeader({ children, actions, navigation, className, inactive = false, profile = false, }) {
    const inactiveProps = inactive ? { inactive } : {};
    const profileProps = profile ? { profile } : {};
    return (React.createElement("tds-page-header", { ...inactiveProps, ...profileProps, class: className },
        children,
        actions && React.createElement("div", { slot: "actions" }, actions),
        navigation && React.createElement("nav", { slot: "navigation" }, navigation)));
}

export { PageHeader };
//# sourceMappingURL=PageHeader.js.map
